import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CreateUsers, CreateUsersInput} from './create-users.model';

export const loadCreateUserss = createAction(
  '[CreateUsers/API] Load CreateUserss',
  props<{ createUserss: CreateUsers[] }>()
);

export const addCreateUsers = createAction(
  '[CreateUsers/API] Add CreateUsers',
  props<{ createUsers: CreateUsers }>()
);

export const upsertCreateUsers = createAction(
  '[CreateUsers/API] Upsert CreateUsers',
  props<{ createUsers: CreateUsers }>()
);

export const addCreateUserss = createAction(
  '[CreateUsers/API] Add CreateUserss',
  props<{ createUserss: CreateUsers[] }>()
);

export const upsertCreateUserss = createAction(
  '[CreateUsers/API] Upsert CreateUserss',
  props<{ createUserss: CreateUsers[] }>()
);

export const updateCreateUsers = createAction(
  '[CreateUsers/API] Update CreateUsers',
  props<{ createUsers: Update<CreateUsers> }>()
);

export const updateCreateUserss = createAction(
  '[CreateUsers/API] Update CreateUserss',
  props<{ createUserss: Update<CreateUsers>[] }>()
);

export const deleteCreateUsers = createAction(
  '[CreateUsers/API] Delete CreateUsers',
  props<{ id: string }>()
);

export const deleteCreateUserss = createAction(
  '[CreateUsers/API] Delete CreateUserss',
  props<{ ids: string[] }>()
);

export const clearCreateUserss = createAction(
  '[CreateUsers/API] Clear CreateUserss'
);


// CUSTOM
export const createCitizenUsers = createAction(
  '[CreateUsers/API] create Citizen Users',
  props<{ input: CreateUsersInput }>()
);
